module.exports = __webpack_public_path__ + "img/ConditionMonitor_einfarbig_RGB.381bbd4c.svg";